import $ from "jquery";

// Function to toggle light/dark mode
function setColorMode(color) {
  if (color == "dark") {
    $(".toggle-dark-mode").children("i").removeClass("bi-moon");
    $(".toggle-dark-mode").children("i").addClass("bi-sun");
  } else {
    $(".toggle-dark-mode").children("i").removeClass("bi-sun");
    $(".toggle-dark-mode").children("i").addClass("bi-moon");
  }

  $("html").attr("data-bs-theme", color);
  localStorage.setItem("color-mode", color);
  $.post("/set-color-mode", { color_mode: color });
}

// Listen for click on light/dark mode button
$(() => {
  $(".toggle-dark-mode").on("click", () => {
    var currentState = $("html").attr("data-bs-theme");

    var newState = "dark";
    if (currentState === "dark") {
      newState = "light";
    }

    setColorMode(newState);
  });
});

// On page load: automatic light/dark toggle
$(() => {
  var currentState = $("html").attr("data-bs-theme");
  var storedState = localStorage.getItem("color-mode");

  if (storedState && storedState !== currentState) {
    return setColorMode(storedState);
  }

  if (currentState === "auto") {
    var newState = "light";
    if (
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
    ) {
      newState = "dark";
    }

    return setColorMode(newState);
  }
});
